var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBordercall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H11.04C11.3197 4.00021 11.5923 4.0884 11.8191 4.25207C12.046 4.41574 12.2156 4.64661 12.304 4.912L14.3013 10.9027C14.4025 11.2071 14.3906 11.5379 14.2676 11.8342C14.1447 12.1305 13.919 12.3726 13.632 12.516L10.6227 14.0227C12.0978 17.2874 14.7126 19.9022 17.9773 21.3773L19.484 18.368C19.6274 18.081 19.8695 17.8553 20.1658 17.7324C20.4621 17.6094 20.7929 17.5975 21.0973 17.6987L27.088 19.696C27.3536 19.7845 27.5846 19.9543 27.7483 20.1814C27.912 20.4085 28.0001 20.6814 28 20.9613V25.3333C28 26.0406 27.719 26.7189 27.219 27.219C26.7189 27.719 26.0406 28 25.3333 28H24C12.9547 28 4 19.0453 4 8V6.66667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBordercall);
export default __webpack_public_path__ + "static/media/bordercall.40d4d4a7c6476bafd9f85f52530fd6be.svg";
export { ForwardRef as ReactComponent };